import React from 'react';
import { Link } from 'react-router-dom';

const CV = () => {
  const textSecondary = 'text-gray-600 dark:text-gray-400';
  const textColor = 'text-gray-900 dark:text-gray-100';

  return (
    <div className="max-w-2xl mx-auto px-6 py-20 pb-32">
      <Link
        to="/"
        className={`mb-8 inline-block ${textSecondary} hover:${textColor} transition-colors text-sm`}
      >
        ← Go Back
      </Link>

      <div className="space-y-12">
        {/* Header */}
        <div>
          <h1 className="text-4xl font-bold mb-4">Victor Mwangi</h1>
          <p className={`text-lg ${textSecondary} mb-4`}>
            Software Engineer | Backend Systems & Enterprise Integrations
          </p>
          <div className={`${textSecondary} text-sm space-y-1`}>
            <p>+254 715 067 724</p>
            <p>mwangiruoya@gmail.com</p>
            <p>Nairobi, Kenya</p>
          </div>
        </div>

        {/* Professional Summary */}
        <div>
          <h2 className="text-2xl font-bold mb-4">Professional Summary</h2>
          <p className={`${textSecondary} leading-relaxed`}>
            Software Engineer with 4+ years specializing in scalable backend systems, enterprise
            integrations, and high-performance data pipelines. Expert in building production-grade APIs
            and microservices using Python (Django, FastAPI), TypeScript, and Go, serving millions of
            daily users with 99.9% uptime. Proven experience architecting e-commerce platforms,
            real-time fraud detection systems, and geospatial applications. Strong foundation in cloud
            infrastructure (Azure, AWS), DevOps practices (Docker, CI/CD), and database optimization
            (PostgreSQL, MongoDB, Redis).
          </p>
        </div>

        {/* Work Experience */}
        <div>
          <h2 className="text-2xl font-bold mb-6">Professional Experience</h2>
          <div className="space-y-8">
            <div>
              <div className="flex justify-between items-start mb-2">
                <h3 className="text-lg font-medium">DigitalQatalyst</h3>
                <span className={`${textSecondary} text-sm`}>Feb 2025 - March 2026 </span>
              </div>
              <h4 className={`${textSecondary} mb-3`}>Backend Engineer</h4>
              <ul className={`${textSecondary} text-sm space-y-2 leading-relaxed`}>
                <li>• Architected custom Vendure plugins establishing bi-directional data sync between Vendure and Microsoft D365 CRM, automating customer data flow, order processing, and inventory management for 500+ enterprise users</li>
                <li>• Designed Azure Active Directory integration implementing enterprise-grade SSO and RBAC with granular permission management</li>
                <li>• Built Azure Blob Storage pipeline with intelligent media optimization reducing costs by 40% for 10,000+ SKU catalogs</li>
                <li>• Extended Vendure's entity model supporting complex B2B requirements; optimized queries reducing API response times from 800ms to 200ms</li>
                <li>• Developed efficient GraphQL API architecture with dataloader patterns, field-level caching, and query complexity analysis</li>
                <li>• Delivered infrastructure enabling $2M+ monthly B2B transactions with 99.9% uptime</li>
              </ul>
            </div>

            <div>
              <div className="flex justify-between items-start mb-2">
                <h3 className="text-lg font-medium">HNG</h3>
                <span className={`${textSecondary} text-sm`}>2023</span>
              </div>
              <h4 className={`${textSecondary} mb-3`}>Backend Software Engineer</h4>
              <ul className={`${textSecondary} text-sm space-y-2 leading-relaxed`}>
                <li>• Engineered Flask RESTful API for user management with JWT authentication and RBAC serving 1,000+ daily active users</li>
                <li>• Architected Django backend for screen recording application with asynchronous task queues (Celery) and cloud storage integration</li>
                <li>• Established testing framework achieving 85%+ code coverage using pytest; implemented automated CI/CD pipelines</li>
                <li>• Reduced average API response times to &lt;150ms through database indexing, query optimization, and caching strategies</li>
              </ul>
            </div>

            <div>
              <div className="flex justify-between items-start mb-2">
                <h3 className="text-lg font-medium">Ramana AI</h3>
                <span className={`${textSecondary} text-sm`}>2023</span>
              </div>
              <h4 className={`${textSecondary} mb-3`}>Data Engineering Intern</h4>
              <ul className={`${textSecondary} text-sm space-y-2 leading-relaxed`}>
                <li>• Engineered end-to-end PySpark pipelines processing 10M+ daily transactions, reducing batch processing time from 6 hours to 45 minutes</li>
                <li>• Architected Apache Kafka streaming pipeline handling 50,000+ events/second with &lt;100ms latency</li>
                <li>• Redesigned PostgreSQL ETL workflows achieving 99.8% data accuracy; implemented partitioning strategies reducing query times by 70%</li>
                <li>• Developed anomaly detection algorithms achieving 92% precision, reducing false positives by 35%</li>
                <li>• Enabled fraud detection across $100M+ annual transaction volume, reducing fraud losses by 40%</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Education */}
        <div>
          <h2 className="text-2xl font-bold mb-6">Education & Certifications</h2>
          <div className="space-y-4">
            <div>
              <div className="flex justify-between items-start mb-1">
                <h3 className="font-medium">Linux Foundation/Andela</h3>
                <span className={`${textSecondary} text-sm`}>2025</span>
              </div>
              <p className={`${textSecondary} text-sm`}>Kubernetes Cloud Native Associate</p>
            </div>

            <div>
              <div className="flex justify-between items-start mb-1">
                <h3 className="font-medium">CyberShujaa</h3>
                <span className={`${textSecondary} text-sm`}>2024</span>
              </div>
              <p className={`${textSecondary} text-sm`}>Security Analysis</p>
            </div>

            <div>
              <div className="flex justify-between items-start mb-1">
                <h3 className="font-medium">Zetech University</h3>
                <span className={`${textSecondary} text-sm`}>2023</span>
              </div>
              <p className={`${textSecondary} text-sm`}>B.Sc. Information Technology</p>
            </div>

            <div>
              <div className="flex justify-between items-start mb-1">
                <h3 className="font-medium">ALX Africa</h3>
                <span className={`${textSecondary} text-sm`}>2023</span>
              </div>
              <p className={`${textSecondary} text-sm`}>Full Stack Software Engineering • Backend Programming Specialization</p>
            </div>
          </div>
        </div>

        {/* Technical Expertise */}
        <div>
          <h2 className="text-2xl font-bold mb-6">Technical Expertise</h2>
          <div className="space-y-4">
            <div>
              <h3 className={`font-medium mb-2`}>Backend Development</h3>
              <p className={`${textSecondary} text-sm leading-relaxed`}>
                Python (Django, Flask, FastAPI) • TypeScript/Node.js • Go (Gin) • RESTful APIs • GraphQL • Microservices Architecture
              </p>
            </div>
            <div>
              <h3 className={`font-medium mb-2`}>Data Engineering</h3>
              <p className={`${textSecondary} text-sm leading-relaxed`}>
                Apache Kafka • PySpark • ETL Pipelines • Real-time Streaming • PostgreSQL • MongoDB • Redis • Neo4j
              </p>
            </div>
            <div>
              <h3 className={`font-medium mb-2`}>Cloud & DevOps</h3>
              <p className={`${textSecondary} text-sm leading-relaxed`}>
                Azure (Active Directory, Blob Storage, App Services) • AWS • Docker • Kubernetes • CI/CD • Linux • Git
              </p>
            </div>
            <div>
              <h3 className={`font-medium mb-2`}>Specialized Skills</h3>
              <p className={`${textSecondary} text-sm leading-relaxed`}>
                E-commerce Platforms (Vendure) • Geospatial Systems (GeoDjango, PostGIS) • Machine Learning Integration • Fraud Detection • CRM Integration (Microsoft D365)
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CV;
